import { render, staticRenderFns } from "./ModalForProducts.vue?vue&type=template&id=62dc2c07&"
import script from "./ModalForProducts.vue?vue&type=script&lang=js&"
export * from "./ModalForProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModalForProducts.vue"
export default component.exports